<template>
  <div class="py-12 selection:bg-secondary selection:text-white">
    <slot name="header" />

    <TContainer size="2xl">
      <GhostFeatureImage
        v-if="data.title && data.feature_image"
        :feature-image="data.feature_image"
        :title="data.title"
        :description="data.meta_description"
      />
    </TContainer>

    <div class="max-w-3xl mx-auto relative p-8 bg-white rounded-t-xl md:-mt-24">
      <THeadingMarketing
        v-if="!$slots?.header"
        :level="2"
        class="mb-8"
      >
        {{ data.title }}
      </THeadingMarketing>

      <div class="flex items-center justify-between mb-4">
        <p
          v-if="hasHeadings"
          class="text-sm font-semibold"
        >
          {{ t('pages.blog.onThisPage') }}
        </p>

        <GhostShare
          v-if="data.title"
          :share-text="data.title"
          class="ml-auto"
        />
      </div>

      <div v-if="hasHeadings">
        <ul class="list-disc pl-4 space-y-2">
          <li
            v-for="(heading, index) in content.headings"
            :key="heading.id ?? `${heading.text}-${index}`"
          >
            <a
              v-if="heading.id"
              :href="`#${heading.id}`"
              class="link"
            >{{ heading.text }}</a>
            <span v-else>{{ heading.text }}</span>
          </li>
        </ul>
      </div>

      <GhostBody
        v-if="content.html"
        :html-body="content.html"
        class="mt-16"
      />
    </div>

    <slot name="footer" />
  </div>
</template>

<script setup lang="ts">
import type { PostOrPage } from '@tryghost/content-api'

const props = defineProps<{
  data: PostOrPage
}>()

const { t } = useI18n()

const content = computed(() => prepareGhostContentHtml(props.data.html ?? ''))

const hasHeadings = computed(() => content.value.headings.length > 0)
</script>

<i18n src="~~/i18n/locales/common/pages/blog.json" lang="json" />
